import React, { useContext } from 'react';
import { ServiceResponse } from '../../../app/services/shared/interfaces';
import { toast } from 'react-toastify';
import useReactConfirmAlert from '../../../hooks/useReactConfirmAlert';
import { AppContext } from '../../../contexts/AppContext';
import ActiveControl from '../../../components/ActiveControl';
import usePaymentMethodService from '../../../app/services/hooks/usePaymentMethodService';

interface Props {
    paymentMethodId: number;
    checkValue: boolean;
    callbackSuccess: () => void;
}

const PaymentMethodSwitchChange = ({ paymentMethodId, checkValue, callbackSuccess }: Props) => {
    const { showLoading, hideLoading } = useContext(AppContext);
    const [checked, setChecked] = React.useState<boolean>(checkValue);
    const { activePaymentMethod, fetchingActivePaymentMethod } = usePaymentMethodService();

    const active = (value: boolean) => {
        setChecked(value);
        activePaymentMethod(paymentMethodId, value, {
            onSuccess: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                useReactConfirmAlert().successAlert({
                    title: 'Éxito',
                    message: response.message
                });
                callbackSuccess();
            },
            onError: (response: ServiceResponse) => {
                if (hideLoading) hideLoading();
                setChecked(!value);
                useReactConfirmAlert().errorAlert({
                    title: 'Error',
                    message: response.message
                });
            }
        });
    };

    return <ActiveControl status={checked} id={paymentMethodId} callback={active} />;
};

export default PaymentMethodSwitchChange;
